import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ButtonGroup, TypedGroupButton } from './button-group.model';
import { EditButtonComponent } from '@retail-portal-santander-frontend/remote-shared-ui-edit-button';
import { ButtonComponent } from '@retail-portal-santander-frontend/remote-shared-ui-button';

@Component({
  standalone: true,
  selector: 'allianz-button-group',
  templateUrl: './button-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, EditButtonComponent, ButtonComponent],
})
export class ButtonGroupComponent {
  buttons = input<ButtonGroup>();

  isTypedButton(button: unknown): button is TypedGroupButton {
    return typeof button?.['btnType'] !== 'undefined';
  }
}
